import KlaroController from '../modules/KlaroController.js';

const initKlaroController = () => {
    new KlaroController('.cookie--change');

    requestAnimationFrame(() => {
        const notice = document.getElementById('klaro-cookie-notice');

        if (notice) {
            notice.classList.add('is-visible');
        }
    });
};

const init = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initKlaroController, {
            once: true
        });
    } else {
        initKlaroController();
    }
};

if (typeof loadjs !== 'undefined') {
    loadjs.ready('js_default', init);
} else {
    init();
}